import { ResponsiveTableCell } from "../../../../components/layout/responsive-table/responsive-table-cell.component";
import React from "react";
import { ProductsTableSavingsBadgeProps } from "./products-table-savings-badge.props";
import { SideBySide } from "../../../../components/side-by-side/side-by-side.component";
import { ProductsTableStatusIndicator } from "../../features/product-status-indicator/components/product-status-indicator/products-table-status-indicator.component";
import { getSavingsBadgeStatus } from "../../types/savings-badge.functions";

export const ProductsTableSavingsBadge = (props: ProductsTableSavingsBadgeProps) => (
  <ResponsiveTableCell className="medium" align="left">
    <SideBySide>
      <span>{props.badge || ""}</span>
      <ProductsTableStatusIndicator
        showIf={false}
        field="Savings Badge"
        status={getSavingsBadgeStatus(props.badge, props.wasBadgeUpdated)}
      />
    </SideBySide>
  </ResponsiveTableCell>
);
